import { render, staticRenderFns } from "./RolesAddEdit.vue?vue&type=template&id=7bfc3ee4"
import script from "./RolesAddEdit.vue?vue&type=script&lang=js"
export * from "./RolesAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports